import React, { useEffect, useRef, useState } from "react";
import { Input } from "@my-scoot/component-library-legacy";
import { useNotify } from "react-admin";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { useFeaturesStore } from "../../store/useFeaturesStore";
import { GRACE_PEROID_VALIDATION_CONSTANTS } from "features/ManageOfferings/modules/Subscriptions/constants/Subscriptions.constants";
import { GRACE_PERIOD_MODAL_STORE_KEYS } from "../../constants/Features.constants";
import useDebounce from "hooks/useDebounce";
import { notification_color_keys } from "utils/hooks";

export const SubscriptionGracePeriodDaysInput = ({ isDebounce }) => {
  const notify = useNotify();
  const isDesktop = useDesktopMediaQuery();
  const isFirst = useRef(true);
  const { gracePeriodDays, handleStoreValChange, handleOpen } =
    useFeaturesStore();
  const [error, setError] = useState({
    err: false,
    helperText: null,
  });
  const {
    setValue: setGracePeriodDaysVal,
    debouncedValue: debouncedGracePeriodDaysValue,
  } = useDebounce({
    inititalValue: gracePeriodDays,
    delay: 500,
  });

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (debouncedGracePeriodDaysValue && isDebounce) handleOpen();
  }, [debouncedGracePeriodDaysValue]);

  const handleInputChange = (val) => {
    if (val <= GRACE_PEROID_VALIDATION_CONSTANTS.MAX_LIMIT) {
      handleStoreValChange(GRACE_PERIOD_MODAL_STORE_KEYS.gracePeriodDays, val);
      setGracePeriodDaysVal(val);
      if (val) {
        setError({ err: false, helperText: null });
      } else {
        setError({ err: true, helperText: "Required" });
      }
    } else {
      notify(
        `Value more than ${GRACE_PEROID_VALIDATION_CONSTANTS.MAX_LIMIT} days is not allowed`,
        notification_color_keys.error
      );
    }
  };

  return (
    <>
      <Input
        value={gracePeriodDays}
        onChange={({ target: { value } }) => handleInputChange(value)}
        inputClassName="tw-bg-white"
        wrapperClassName={!isDesktop ? "w-100 !tw-mt-[-4px]" : "tw-w-[35%] "}
        error={error.err}
        helperText={error.helperText}
        fullWidth
      />
      <p className="!tw-ml-[10px] tw-text-[16px] tw-font-medium"> Days </p>
    </>
  );
};
